'use strict';

export default class Clustering {

  constructor() {
    if (Clustering.instance) {
      return Clustering.instance;
    }

    this.init();
    this.handlers();

    Clustering.instance = this;
  }

  remove() {
    TWER.clustersLayers.forEach(layer => {
      TWER.map.removeLayer(layer)
    })
  }

  init() {
    this.clusterCircleLayerName = 'clustering-circles-layer';
    this.clusterCircleCounterLayerName = 'clustering-counters-layer';

    TWER.map.addLayer({
      id: this.clusterCircleLayerName,
      type: 'circle',
      source: TWER.clusterSources,
      filter: ['has', 'point_count'],
      paint: {
        'circle-color': TWER.data.clusterColor,
        'circle-radius': TWER.data.cluster.radius,
        'circle-stroke-color': TWER.data.cluster.borderColor,
        'circle-stroke-width':  TWER.data.cluster.borderSize,
      }
    });
    TWER.map.addLayer({
      id: this.clusterCircleCounterLayerName,
      type: 'symbol',
      source: TWER.clusterSources,
      filter: ['has', 'point_count'],
      layout: {
        'text-field': ['get', 'point_count_abbreviated'],
        'text-size': TWER.data.cluster.fontSize,
      },
      paint: {
        'text-color': TWER.data.cluster.fontColor
      }
    });

    TWER.clustersLayers = [this.clusterCircleLayerName, this.clusterCircleCounterLayerName]
  }



  handlers() {
    TWER.map.on('click', this.clusterCircleLayerName, (e) => {
      const features = TWER.map.queryRenderedFeatures(e.point, {
        layers: [this.clusterCircleLayerName]
      });
      const clusterId = features[0].properties.cluster_id;
      TWER.map.getSource(TWER.clusterSources).getClusterExpansionZoom(
        clusterId,
        (err, zoom) => {
          if (err) return;

          TWER.map.easeTo({
            center: features[0].geometry.coordinates,
            zoom: zoom
          });
        }
      );
    });


    TWER.map.on('mouseenter', this.clusterCircleLayerName, (e) => {
      window.TWER.clusterHover = true;
      TWER.map.getCanvas().style.cursor = 'pointer';
    });


    TWER.map.on('mouseleave', this.clusterCircleLayerName, () => {
      window.TWER.clusterHover = false;
      TWER.map.getCanvas().style.cursor = '';
    });

  }

}
